import { render, staticRenderFns } from "./job-form-specs-delivery.vue?vue&type=template&id=1f993f1a"
import script from "./job-form-specs-delivery.vue?vue&type=script&lang=js"
export * from "./job-form-specs-delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports